import React, {Component} from 'react';
import './Summary.css';

class Summary extends Component {


    render() {
        return (

            <div id="summary" className="row home-block">

                <div className="">
                    <h1>En quelques lignes</h1>

                    <h5>Maître de conférences en informatique à l'<a target="_blank" href="https://www.univ-tlse3.fr/" rel="noopener noreferrer">Université de Toulouse Paul Sabatier</a> au laboratoire <a target="_blank" href="https://www.irit.fr/" rel="noopener noreferrer">I.R.I.T.</a> dans l'équipe <a target="_blank" href="https://www.irit.fr/ADRIA/site/" rel="noopener noreferrer">A.D.R.I.A.</a>
					</h5>
                    <p> Mes sujets de prédilection sont:</p>
                    <ul><li>Les modèles de bandits</li>
                    <li>Les statistiques</li>
                    <li>Les séries temporelles</li>
                    <li>L'apprentissage par renforcement </li>
                    <li>Les systèmes de recommandation</li>
                    </ul>


					<p> J'ai collaboré avec l'entreprise <a target="_blank" href="https://www.abtasty.com/fr/" rel="noopener noreferrer">AB Tasty</a> et l'entreprise <a target="_blank" href="https://www.yourdata.fr/" rel="noopener noreferrer">Your Data</a> dans le cadre de mes recherches.</p>        
                    <p>J'ai également enseigné l'informatique et les statistiques à 
                    l'<a target="_blank" href="https://www.univ-tlse3.fr/" rel="noopener noreferrer">Université de Toulouse Paul Sabatier</a>,
					 l'<a target="_blank" href="http://www.unistra.fr/index.php?id=accueil&utm_source=unistra_fr&utm_medium=unistra_fr_homepage" rel="noopener noreferrer">Université de Strasbourg</a> et à l'école d'ingénieurs <a target="_blank" href="https://www.esiea.fr" rel="noopener noreferrer">E.S.I.E.A</a>.</p>


                    <p>Attirée par la pédagogie et les statistiques, j'explore par l'informatique et les mathématiques, les secrets du monde qui nous entourent.</p>

                    <p>Pour plus d'information vous pouvez me contacter  <a href="mailto: emmanuelle.claeys@irit.fr">par mail</a>. </p>


                </div>

            </div>

        );
    }
}

export default Summary;



// WEBPACK FOOTER //
// ./src/Components/Summary/Summary.js